import { ACTION_STATES, ComplexAction, createHandler, createReducer, DefaultAction } from "core/actions";
import { get } from "lodash";
import { DATE_FORMAT_SHORT, formatDate } from "components/common/dateUtils";
import {assertString} from "core/validation";

const initState = {
    searchForm: {
        filmRelease: null,
        filmReleaseType: null,
        film: null,
        filmName: null,
        company: null,
        filmRating: null,
        filmRatingReason: null,
        filmReleaseDateBegin: null,
        filmReleaseDateEnd: null,
        filmDateCertifiedBegin: null,
        filmDateCertifiedEnd: null,
        filmDateEnteredBegin: null,
        filmDateEnteredEnd: null,
        advName: null,
        advStatus: null,
        advInstructions: null,
        assocPrivNotes: null,
        advEnteredDateStart: null,
        advEnteredDateEnd: null,
        advertisementExistingTypes: [],
    },
    loadStatus: ACTION_STATES.NO_REQUEST,
    list: [],
    totalCount: 0,
    maxResults: 10,
    page: 0,
    isListView: false,
    selectedFilmRelease: null,
    frSelectionStatus: ACTION_STATES.NO_REQUEST,
    frHistoryStatus: ACTION_STATES.NO_REQUEST,
    frHistoryList: [],
    order: "DESC",
    orderBy: "ENTERED_DATE",
    reloadingFilm: ACTION_STATES.NO_REQUEST,
    deletingFilmId: null,
    deleteStatus: ACTION_STATES.NO_REQUEST,
};

export class REFRESH_TABLE extends ComplexAction {
    sendRdx(state) {
        return Object.assign({}, state, {
            loadStatus: ACTION_STATES.SEND,
        });
    }
}

export class ON_SEARCH_FILM_RELEASE extends ComplexAction {
    sendRdx(state, { payload }) {
        const searchForm = Object.assign({}, state.searchForm, { ...payload });
        return Object.assign({}, state, {
            searchForm,
            isListView: true,
            list: [],
            totalCount: 0,
            page: 0,
            loadStatus: ACTION_STATES.SEND,
        });
    }

    successRdx(state, { payload }) {
        return Object.assign({}, state, {
            list: payload.list,
            totalCount: payload.total,
            isListView: true,
            loadStatus: ACTION_STATES.SUCCESS,
            frHistoryList: []
        });
    }
}
export class ON_SELECT_FILM_RELEASE extends DefaultAction {
    callRdx(state, action) {
        const searchForm = Object.assign({}, state.searchForm, {
            filmRelease: action.payload,
        });
        return Object.assign({}, state, {
            searchForm,
            isListView: false,
            frHistoryList: []
        });
    }
}
export class ON_SEARCH_FILM_RELEASE_HISTORY extends ComplexAction {
    sendRdx(state) {
        return Object.assign({}, state, {
            frHistoryStatus: ACTION_STATES.SEND,
        });
    }

    successRdx(state, { payload }) {
        let listHistory = state.frHistoryList;
        let id = null;
        if (listHistory.length > 0) {
            id = listHistory.map(item => item[0].entityId)[0];
            if (payload.frHistory.length > 0 && payload.frHistory[0].entityId !== id) {
                listHistory.push(payload.frHistory);
            }
        }
        else if(payload.frHistory.length > 0) {
            listHistory.push(payload.frHistory);
        }
        return Object.assign({}, state, {
            ...payload,
            frHistoryList: listHistory,
            frHistoryStatus: ACTION_STATES.SUCCESS,
        });
    }
}

export class ON_CHANGE_PAGINATION_PAGE extends DefaultAction {
    callRdx(state, { payload }) {
        return Object.assign({}, state, {
            page: payload,
            loadStatus: ACTION_STATES.SEND,
        });
    }
}
export class ON_CHANGE_PAGINATION_MAX_RESULTS extends DefaultAction {
    callRdx(state, { payload }) {
        return Object.assign({}, state, {
            page: 0,
            loadStatus: ACTION_STATES.SEND,
            maxResults: payload,
        });
    }
}

export class ON_CHANGE_ORDER extends DefaultAction {
    callRdx(state, { payload }) {
        return {
            ...state,
            order: payload.order,
            orderBy: payload.orderBy,
        };
    }
}

export class ON_DELETE_FILM extends ComplexAction { }










export const actions = {
    ON_SEARCH_FILM_RELEASE: new ON_SEARCH_FILM_RELEASE({ loadingAtr: "loadStatus" }),
    ON_SELECT_FILM_RELEASE: new ON_SELECT_FILM_RELEASE({ loadingAtr: "frSelectionStatus" }),
    ON_SEARCH_FILM_RELEASE_HISTORY: new ON_SEARCH_FILM_RELEASE_HISTORY({ loadingAtr: "frHistoryStatus" }),
    ON_CHANGE_PAGINATION_PAGE: new ON_CHANGE_PAGINATION_PAGE("page"),
    ON_CHANGE_PAGINATION_MAX_RESULTS: new ON_CHANGE_PAGINATION_MAX_RESULTS("maxResults"),
    REFRESH_TABLE: new REFRESH_TABLE({ loadingAtr: "loadStatus" }),
    ON_CHANGE_ORDER: new ON_CHANGE_ORDER(),
    ON_DELETE_FILM: new ON_DELETE_FILM({ loadingAtr: "deleteStatus" }),
    OPEN_DELETE_MODAL: new DefaultAction("deletingFilmId"),

};

const handlers = createHandler(actions);

export default createReducer(initState, handlers);


export const filmSearchSelector = ({ filmReleaseList: { searchForm, order, orderBy } }) => {
    return {
        filmReleaseType: searchForm.filmReleaseType,
        company: get(searchForm.company, "value", null),
        film: searchForm.film? searchForm.film.value: null,
        filmName: assertString(searchForm.filmName) && !searchForm.film?.value ? searchForm.filmName : null,
        filmRating: get(searchForm.filmRating, "value", null),
        filmRatingReason: searchForm.filmRatingReason,
        filmReleaseDateBegin:
            searchForm.filmReleaseDateBegin && formatDate(searchForm.filmReleaseDateBegin, DATE_FORMAT_SHORT),
        filmReleaseDateEnd: searchForm.filmReleaseDateEnd && formatDate(searchForm.filmReleaseDateEnd, DATE_FORMAT_SHORT),
        filmDateCertifiedBegin:
            searchForm.filmDateCertifiedBegin && formatDate(searchForm.filmDateCertifiedBegin, DATE_FORMAT_SHORT),
        filmDateCertifiedEnd:
            searchForm.filmDateCertifiedEnd && formatDate(searchForm.filmDateCertifiedEnd, DATE_FORMAT_SHORT),
        filmDateEnteredBegin:
            searchForm.filmDateEnteredBegin && formatDate(searchForm.filmDateEnteredBegin),
        filmDateEnteredEnd: searchForm.filmDateEnteredEnd && formatDate(searchForm.filmDateEnteredEnd),
        advertisingName: searchForm.advName,
        reviewStatus: searchForm.advStatus && searchForm.advStatus.value,
        advertisementInstruction: searchForm.advInstructions,
        advertisementPrivateNotes: searchForm.assocPrivNotes,
        advertisementDateEnteredBegin:
            searchForm.advEnteredDateStart && formatDate(searchForm.advEnteredDateStart).format("YYYY-MM-DD"),
        advertisementDateEnteredEnd:
            searchForm.advEnteredDateEnd && formatDate(searchForm.advEnteredDateEnd).format("YYYY-MM-DD"),
        advertisementExistingTypes: searchForm.advertisementExistingTypes.map((at) => at.value).join(","),
        order: `${orderBy}_${order}`,
    };
};
export const filmReleaseSelector = ({ filmReleaseList }) => {
    return {
        id: get(filmReleaseList.searchForm, "filmRelease.id", null),
    };
};
export const tablePaginationSelector = ({ filmReleaseList }) => {
    return {
        maxResults: filmReleaseList.maxResults,
        firstResult: filmReleaseList.page * filmReleaseList.maxResults,
    };
};
